import { render, staticRenderFns } from "./TruckSelection.vue?vue&type=template&id=13ebd4ec&scoped=true"
import script from "./TruckSelection.vue?vue&type=script&lang=js"
export * from "./TruckSelection.vue?vue&type=script&lang=js"
import style0 from "./TruckSelection.vue?vue&type=style&index=0&id=13ebd4ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ebd4ec",
  null
  
)

export default component.exports